import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden" aria-labelledby="hero-heading">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20illustration%20with%20warm%20coral%20and%20gold%20accents%2C%20soft%20gradient%20abstract%20background%2C%20elegant%20artistic%20composition%2C%20modern%20minimalist%20design%2C%20subtle%20texture%2C%20cinematic%20warm%20lighting%2C%20atmospheric%20digital%20art%2C%20flowing%20decorative%20elements%2C%20no%20text&width=1600&height=800&seq=hero-banner-01&orientation=landscape"
        alt="韩漫屋 - 好看的韩国漫画免费在线观看"
        className="absolute inset-0 w-full h-full object-cover object-center"
        title="韩漫屋 - 韩漫大全 好看韩国漫画"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <h1 id="hero-heading" className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
          韩漫屋 - 韩漫大全
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          官方认证韩漫官网站，提供好看韩国漫画免费在线观看<br className="hidden sm:block" />
          海量热门韩漫每日更新，高清画质畅快阅读体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/hot"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-fire-line mr-2"></i>
            热门推荐
          </Link>
          <Link
            to="/category/all"
            className="px-8 py-3 rounded-full bg-white/15 text-white font-medium text-sm hover:bg-white/25 transition-all duration-300 backdrop-blur-sm cursor-pointer whitespace-nowrap"
          >
            <i className="ri-book-open-line mr-2"></i>
            全部漫画
          </Link>
        </div>
        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">15,000+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">海量韩漫</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">500万+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">活跃读者</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">每日更新</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">最新章节</p>
          </div>
        </div>
      </div>
    </section>
  );
}